import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import qs from "qs";

import LoginForm from "./LoginForm";
import RecoverForm from "./RecoverForm";
import RegisterForm from "./RegisterForm";
import ResetForm from "./ResetForm";
import { changeLogin } from "../../redux/actions/options";

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pathname: "login",
        };

        this._onPress = this._onPress.bind(this);
        this._onTabPress = this._onTabPress.bind(this);
    }

    componentDidMount() {
        const { location } = this.props;

        const params = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.token = params.token;

        if (this.token) {
            this._onTabPress("reset");
            setTimeout(() => {
                this.props.changeLogin(true);
            }, 700);
        }
    }

    _onPress() {
        this.props.changeLogin(false);

        if (this.state.pathname === "reset") {
            setTimeout(() => {
                this._onTabPress("login");
            }, 700);
        }
    }

    _onTabPress(pathname) {
        this.setState({ pathname });
    }

    _renderOverlay() {
        const { isVisible } = this.props;

        let className = "z-20 fixed inset-0 bg-black transition duration-500";
        if (isVisible) {
            className += " opacity-60 pointer-events-auto";
        } else {
            className += " opacity-0 pointer-events-none";
        }

        return (
            <div className={className} onClick={this._onPress}>
                <div className="absolute inset-0 bg-gray-500 opacity-75" />
            </div>
        );
    }

    render() {
        const { pathname } = this.state;
        const { isVisible } = this.props;

        return (
            <div>
                <Helmet>{isVisible && <body className="modal-open" />}</Helmet>
                {this._renderOverlay()}
                {pathname === "login" && (
                    <LoginForm
                        isVisible={isVisible}
                        pathname={pathname}
                        onClosePress={this._onPress}
                        onTabPress={this._onTabPress}
                        onRecoverPress={this._onTabPress}
                        onLoginSuccess={this._onPress}
                    />
                )}
                {pathname === "recover" && (
                    <RecoverForm
                        isVisible={isVisible}
                        pathname={pathname}
                        onTabPress={this._onTabPress}
                        onClosePress={this._onPress}
                        onBackPress={this._onTabPress}
                    />
                )}
                {pathname === "register" && (
                    <RegisterForm
                        isVisible={isVisible}
                        pathname={pathname}
                        onClosePress={this._onPress}
                        onTabPress={this._onTabPress}
                        onRegisterSuccess={this._onPress}
                    />
                )}
                {pathname === "reset" && (
                    <ResetForm
                        isVisible={isVisible}
                        pathname={pathname}
                        token={this.token}
                        onClosePress={this._onPress}
                        onRegisterSuccess={this._onPress}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isVisible: state.options.isLoginVisible,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeLogin,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
